import $ from "jquery";
import TabCell from "../TabCell";
import {GoingUtils,AssertUtils} from "goingutils";
import {
    _dataFromMap,
    _initSplitBarEvent,
} from "../comJs";
import GridPanelUtils from "./gridPanelUtils";
import GoTabUrl from "../goTabsUrl";

class RoleTab extends TabCell {
    constructor(vueObj, goTabs) {
        super();
        this.tabId = GoingUtils.getUUid(10);

        let tabCellId="role";
        this.tabIdName = tabCellId;
        this.dataFrom = "role";
        this.dataFromLabel = "角色";
        this.filter=false;
        this.tabLabel = _dataFromMap[tabCellId];

        this.active = false;
        this.hasType=vueObj.hasType;
        this.hasSaveGroup = false;
        this.initFirstData = false;
        if (AssertUtils.isNotEmpty(vueObj.value)) {
            this.defVals = vueObj.value;
        }
        this.goTabs = goTabs;
        this.excludeIds=this.goTabs.excludeIds;
    }

    getLeftCellContent(panelHeight) {
        //缓存其panel的高度
        this.leftTopCellHeight = parseFloat(panelHeight + "") - 40;
        return `${GridPanelUtils.initLeftCellContent(this, this.leftTopCellHeight + "px", this.leftTopCellHeight - 5 + "px", "请输入角色名称", this.tabId, false, 160, 180)}`;
    }

    getRightCellContent(panelHeight) {
        return `${GridPanelUtils.initRightCellContent(panelHeight, this, 310)}`;
    }

    allCheckBoxClick() {
        throw new Error("Method not implemented.");
    }

    //选择账套触发
    changeAccountEvent(nodeId, cellObj) {
        if (AssertUtils.isNotEmpty(nodeId)) {
            cellObj.initFirstData = true;
            cellObj.leftTopGrid.flushGridByUrl({
                url: GoTabUrl.queryRoleByAccountId(nodeId),
                params: GridPanelUtils.getLoadGridParams(cellObj, nodeId),
                backFun:()=>{
                    this.excludeIds&&this.excludeIds.forEach((recordId)=>{
                        if(AssertUtils.isNotEmpty(recordId)){
                            cellObj.leftTopGrid.deleteRow(recordId);
                        }
                    });
                }
            });
        }
    }


    //将数据添加到已选表格中
    addLeftTopRecordToAlreadyGrid(rowId, orgGrid) {
        GridPanelUtils._addLeftTopRecordToAlreadyGrid(this, rowId, orgGrid, this.dataFromLabel,"roleName",this.dataFrom);
    }


    removeSelectedRecord() {
        throw new Error("Method not implemented.");
    }

    /**
     * tab销毁操作
     */
    destructionTab() {
        //销毁公共组件
        this._desCommonCtl();
        //销毁岗位列表信息
        if (this.leftTopGrid != null && AssertUtils.isFunction(this.leftTopGrid.destructor)) {
            this.leftTopGrid.destructor();
            this.leftTopGrid = null;
        }
    }

    loadSysDefData() {

    }

    initRoleGridMethod() {
        let cellObj = this;
        cellObj.itemConfig["selLeftTopRecord"] = true;
        //待选数据
        cellObj.leftTopGrid = GridPanelUtils.initRoleGrid(cellObj, true, true, true);
        cellObj.leftTopGrid.selAllRecord=function(flag){
            //将所有数据放入到已选
            if(flag){
                cellObj.leftTopGrid.forEachRow(function (rowId) {
                    cellObj.addLeftTopRecordToAlreadyGrid(rowId,cellObj.leftTopGrid);
                });
            }else{
            //从已选数据中清空当前列表到数据
                cellObj.leftTopGrid.forEachRow(function (rowId) {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                });
            }

        };
    }

    //初始化tabcell的容器控件
    initTabCellCtl() {
        this.initRoleGridMethod();
        //待选择数据的表格
        this.initAlreadyGrid(this.hasType);
        //设置缺少值
        this.initDefEvent({
            topHeight: 70,
            searchFun: () => {
                this.leftTopGrid.reloadData(GridPanelUtils.getLoadGridParams(this));
            },
            //查询右边已选的数据表格
            searchAlSelFun: () => {
                this.searchAlSelGrid();
            }
        });
        //初始化账套缺省默认值
        this.initAccountDefVal(this.getLoadFormStorageFlag(), this);
        this.initCtlEvent();
    }

    //初始化控件事件
    initCtlEvent() {
        var tabCellObj = this;
        //初始化分隔栏的事件
        _initSplitBarEvent(tabCellObj);
        this.initIconBtnEvent();
        this.searchAlReadyRecord(this);
    }
}

function initRoleTab(goTabs, vueObj) {
    let groupTab = new RoleTab(vueObj, goTabs);
    goTabs.addTabToFactory("role", groupTab);
}

export default initRoleTab;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/roleTab.js